export default __webpack_public_path__ + "static/media/UI-360.37145c7e.png";